import { BrickContext, Brick, registerBrick } from 'olympe';

export default class ConsoleLog extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} level
     * @param {string} context
     * @param {*} object
     * @param {function(*)} setObject
     */
    update($, [level, context, object], [setObject]) {
        console[level](context+':', object);
        setObject(object);
    }
}

registerBrick('01931544543cbe20595a', ConsoleLog);
